import { ButtonLinkWithTooltip } from './ButtonLinkWithTooltip';
import { ButtonWithTooltip } from './ButtonWithTooltip';
import { IconButtonLinkWithTooltip } from './IconButtonLinkWithTooltip';
import { IconButtonWithTooltip } from './IconButtonWithTooltip';
import { LinkButtonWithTooltip } from './LinkButtonWithTooltip';
import { LinkWithTooltip } from './LinkWithTooltip';

export * from './context';
export * from './types';
export * from './Tooltip';
export * from './useTooltip';
export * from './useTooltipContext';

export * from './ButtonWithTooltip';
export * from './ButtonLinkWithTooltip';
export * from './IconButtonLinkWithTooltip';
export * from './IconButtonWithTooltip';
export * from './LinkWithTooltip';
export * from './LinkButtonWithTooltip';

export const WithTooltip = {
  Button: ButtonWithTooltip,
  ButtonLink: ButtonLinkWithTooltip,
  IconButton: IconButtonWithTooltip,
  IconButtonLink: IconButtonLinkWithTooltip,
  Link: LinkWithTooltip,
  LinkButton: LinkButtonWithTooltip,
};
